import { buildAccessRights } from '@shared/constants';

import type { PermissionEnum } from '@shared/api';

export type AssignablePermission = Exclude<PermissionEnum, 'OWNER'>;

export const ASSIGNABLE_TEAM_PERMISSIONS: AssignablePermission[] = ['ADMIN', 'MANAGER'];

export const DEFAULT_TEAM_INVITE_PERMISSION: AssignablePermission = 'MANAGER';

export const buildAssignablePermissionOptions = (t: Parameters<typeof buildAccessRights>[0]) => {
  const accessRights = buildAccessRights(t);

  return ASSIGNABLE_TEAM_PERMISSIONS.map((permission) => ({
    value: permission,
    label: accessRights[permission].title,
    description: accessRights[permission].description,
  }));
};
